import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Facebook ads: good for likes, bad for sales",
  "description": "",
  "published": "2013-06-12T00:00:00.000Z",
  "redirect_from": ["/blog/facebook-ads-good-for-likes-bad-for-sales/swizec/6233"],
  "categories": "Advertising, Business, Facebook, Pay per click, Reddit, Side Projects, Social network",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/xfezkcGEQGK22QyduFl4",
        "alt": "Campaign run graph",
        "title": "Campaign run graph"
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "http://facebook.com",
        "title": "Facebook"
      }}>{`Facebook Ads`}</a>{` have a simple promise - you make an ad, you target it to a very specific demographic, your ad instantly reaches millions of people and if even a small percentage of those convert that's still a shitload of sales.`}</p>
    <p>{`And so I went, testing the waters of online advertising with a tiny budget of $15 a day. Promoting `}<a parentName="p" {...{
        "href": "https://leanpub.com/nightowls"
      }}>{`my ebook`}</a>{` just a little bit so I know what to expect.`}</p>
    <p>{`I decided to go for two ad types - the news feed and the sidebar on the right. My campaign ran for 12 days, May 27th to June 8th and had a potential reach of 32,000,000 people. All interested in technology, launching tech businesses and being early adopters.`}</p>
    <p>{`Unfortunately I couldn't target for `}<em parentName="p">{`"In a relationship with somebody like the above."`}</em>{`. Bummer, but this demographic will do.`}</p>
    <h2 {...{
      "id": "the-effect"
    }}>{`The effect`}</h2>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/5QEjVcxuRLezUjQGb11Q",
        "alt": "Effect on traffic",
        "title": "Effect on traffic"
      }}></img></p>
    <p>{`In those 12 days I spent $158.91 and made 15 sales - $65.85 in royalties. A loss of almost 60%, made worse by the fact many of the sales didn't come through facebook. But the news feed post did get 45 likes and the facebook page I haven't made yet got 61 likes.`}</p>
    <p>{`How does a page that doesn't exist get 61 likes anyway? Guess I have to make it now.`}</p>
    <p>{`All in all, my ads had a reach of 88,738 people. About 55k for the news feed ad and about 33k for the right side ad. A far cry from the 32 million potential I was offered, but hey, that $15/day budget didn't last very long.`}</p>
    <p>{`Comparing conversions for the two ads is pretty interesting as well.`}</p>
    <p>{`The news feed ad got 1,418 clicks (like or link) with a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Click-through_rate",
        "title": "Click-through rate"
      }}>{`click-through rate`}</a>{` of 2.44%, while the sidebar ad stacked up a measly 11 clicks for a click-through rate of just 0.012%.`}</p>
    <p>{`Sidebar clicks cost more too - $0.58 vs. $0.11 for the news feed.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/EfMY6HFATWCyck4BcKKf",
        "alt": "Conversions",
        "title": "Conversions"
      }}></img></p>
    <p>{`Despite the significant increase in traffic for the 12 days, it seems that either Facebook users aren't very interested in buying, or my landing page is terrible at converting traffic into sales.`}</p>
    <p>{`For my next experiment I'll use `}<a parentName="p" {...{
        "href": "http://www.google.com/adsense",
        "title": "AdSense"
      }}>{`Google Ads`}</a>{` and see what happens there. I think `}<a parentName="p" {...{
        "href": "http://stackoverflow.com/",
        "title": "Stack Overflow"
      }}>{`StackOverflow`}</a>{` and possibly `}<a parentName="p" {...{
        "href": "http://reddit.com/",
        "title": "Reddit"
      }}>{`Reddit`}</a>{` would make a good experiment as well.`}</p>
    <hr></hr>
    <p>{`The raw facts for those interested:`}</p>
    <p><strong parentName="p"><a parentName="strong" {...{
          "href": "http://en.wikipedia.org/wiki/Facebook_features",
          "title": "Facebook features"
        }}>{`News Feed`}</a>{` Ad`}</strong>{` 51,081 reach 1,293 link clicks 1,418 clicks 2.44% click-through rate $0.11 per click, $153.71 spent`}</p>
    <p>{`61 Page Likes 45 Page Post Likes`}</p>
    <p><strong parentName="p">{`Right Bar Ad`}</strong>{` 37,657 reach 11 Link Clicks 9 Clicks 0.012% click-through rate $0.58 per click, $5.20 spent`}</p>
    <p>{`Sales made: 15 `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Royalties",
        "title": "Royalties"
      }}>{`Royalties`}</a>{` made: $65.85`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=34a81a15-21e0-48be-81e3-07788317f1a8",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      